import { ROUTES } from './constants'

export function isResumeOnlyMode(): boolean {
  const raw = import.meta.env.VITE_RESUME_ONLY_MODE
  if (raw === undefined || raw === null || raw === '') return false
  if (raw === false) return false
  const normalized = String(raw).trim().toLowerCase()
  if (normalized === 'false' || normalized === '0' || normalized === 'no' || normalized === 'off') {
    return false
  }
  return true
}

function getAppHomePath(): string {
  return isResumeOnlyMode() ? ROUTES.RESUMES_LIST : '/'
}

/** Default authenticated landing after login or OAuth callback. */
export function getPostAuthLandingPath(options: { onboardingComplete: boolean }): string {
  if (!options.onboardingComplete) {
    return ROUTES.ONBOARDING_STEP_1
  }
  return getAppHomePath()
}

/** Where to send the user after email confirm or equivalent post-auth aux flow. */
export function getPostEmailConfirmPath(onboardingComplete: boolean): string {
  if (!onboardingComplete) {
    return ROUTES.ONBOARDING_STEP_1
  }
  return getAppHomePath()
}
